window.localizedStrings["contentmanager"] = {
  editorpaneerror: "Editor pane is missing from the content management form",
  propertyeditorerror:
    "Property editor is missing from the content management form",
  duplicatecontrolidwarning:
    "Warning: A duplicate control id {0} was found on this page.  This can cause unexpected results in this designer.  We recommend you edit this file by hand and resolve the naming conflict.",
  idpropertyerror: "The id property may not be empty",
  valididerror: '" {0} " is not a valid id.',
  idalreadyusederror: 'The id " {0} " is already in use by another control',
  action: "Action",
  delete: "Delete Confirmation",
  relativepositiondraggingerror:
    "A relatively positioned control cannot be dragged within the current viewer.   Use the property editor to change the control�s visual appearance.",
  nocontrolbyid: 'Unable to find the control with id "{0}"',
  nooptionsforcontrol: 'Unable to get the options for control with id "{0}"',
  taborderoutofrange:
    "Tab order is out of allowable range.  Maximum value allowed is ",
  taborder: "Tab Order",
  zerotaborder: "Setting the tab order as zero is not supported",
  tabordertoobig:
    "Setting the tab order higher than the number of controls is not supported",
  taborderparent:
    "This tab index is not allowed as it would change the parent group.  Please check that the control attempting to be changed is part of the correct parent group.",
  addcontrol: "Add Control"
};
